<script setup lang="ts">
defineProps<{
  colorTheme?: string
}>()
</script>

<template>
  <div :class="`flex gap-[0.3rem] items-center ${colorTheme}`">
    <IconsGraphicsLine
      fill="var(--foreground)"
      width="45"
      height="2"
    />
    <IconsGraphicsStarIcon fill="var(--foreground)" />
  </div>
</template>
